<template>
    <form
        ref="submitPaymentForm"
        method="POST"
        charset="UTF-8"
        action="https://payment.architrade.com/paymentweb/start.action"
    >
        <input
            v-for="input in inputs"
            :key="input.name"
            :type="inputType"
            :name="input.name"
            :value="input.value"
        />
    </form>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            inputType: "hidden",
            // Currency ID. 208 = DKK
            currency: "208",
            // TODO consider letting the path be found more intelligently
            accepturl: window.location.origin + "/payment/"
        };
    },
    computed: {
        dibslang() {
            switch (this.$i18n.locale) {
                case "da":
                    return "Danish";
                case "de":
                    return "German";
                default:
                    return "English";
            }
        },
        debugInputs() {
            return [
                {
                    name: "test",
                    value: "yes"
                }
            ];
        },
        inputs() {
            const inputs = [
                {
                    name: "accepturl",
                    value: this.accepturl
                },
                {
                    name: "provider",
                    value: "Dibs"
                },
                {
                    name: "currency",
                    value: this.currency
                },
                {
                    name: "merchant",
                    value: this.getDibsMerchantId
                },
                {
                    name: "lang",
                    value: this.dibslang
                },
                {
                    name: "orderid",
                    value: this.orderId
                },
                {
                    name: "reference",
                    value: this.orderId
                },
                {
                    name: "amount",
                    value: this.orderPriceOre
                }
            ];

            if (process.env.VUE_APP_SERVER !== "live") {
                inputs.push(...this.debugInputs);
            }
            return inputs;
        },
        ...mapGetters({
            orderId: "order/getOrderId",
            orderPriceOre: "order/getPriceOre",
            getDibsMerchantId: "system/getDibsMerchantId"
        })
    },
    mounted() {
        this.$emit("loading", "Redirecting to DIBS");
        Vue.nextTick().then(() => {
            // DOM updated
            this.$refs.submitPaymentForm.submit();
        });
    }
};
</script>
